import React, { useMemo, useState, useEffect } from 'react';
import RegisterCanvas from './Canvas';
import AccessChartCanvas from './AccessChartCanvas';
import CustomerCanvas from './CustomerCanvas';
import ReportCanvas from './AccessReportCanvas';

import ChartIcon from '@mui/icons-material/InsertChart';
import ContactsRoundedIcon from '@mui/icons-material/ContactsRounded';

import { 
  ReportIcon,
  ResponseStatus,
  Table,
  TableIconButton,
  useMessageDispatch,
} from 'itaf';

import CustomerService from '../../services/CustomerService';
import NotificationService from '../../services/NotificationService';
import UserService from '../../services/UserService';
import { IconButton, Tooltip } from '@mui/material';

export default function RegisterContainer(props) {
  const setMessage = useMessageDispatch();
  const [tableRef, setTableRef] = useState();

  const [canvasClose, setCanvasClose] = useState(false);
  const [dados, setDados] = useState([]);
  const [products, setProducts] = useState([]);
  const [user, setUser] = useState({});
  const [isLoading, setLoading] =  useState(false);
  const [isSaving, setSaving] =  useState(false);
  const [isValidCanvas, setValidCanvas] =  useState(false);
  const [customers, setCustomers] = useState([]);
  const [openCustomer, setOpenCustomer] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [openReport, setOpenReport] = useState(false);

  useEffect(() => {
    setLoading(true);

    loadProducts();

    loadCustomers();

    loadUsers();
  }, []);

  function loadUsers() {
    UserService.fetchRegisteredUsers()
      .then((response) => {
        if (ResponseStatus.OK === response.status) {
          (async () => {
            const result = await response.json();
            setDados(result);
          })();
        }
        else {
          setMessage({ hasError: true, text: 'Não foi possível carregar usuários cadastrados.' });
          setDados([]);
        }
      })
      .catch(() => {
        setMessage({ hasError: true, text: 'Verifique se está logado e com conexão de internet.' });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function loadProducts() {
    const errorText = "Não foi possível buscar todos os produtos disponíveis, ainda é possível terminar o cadastro e liberar acesso aos produtos depois!";
    UserService.fetchProducts()
      .then((response) => {
        if (ResponseStatus.OK === response.status) {
          (async () => {
            const result = await response.json();
            setProducts(result);
          })();
        }
        else {
          setMessage({ hasError: true, text: errorText });
          setProducts(null);
        }
      })
      .catch(() => {
        setMessage({ hasError: true, text: 'Verifique se está logado e com conexão de internet.' });
      });
  }

  const [listExpanded, setListExpanded] = useState([]);

  function expandUser(expanded) {
    const list = Object.entries(expanded).filter(([_managerId, isExpanded]) => isExpanded).map(([id]) => id);
    if (list.length <= 0) {
      setListExpanded([]);
      return;
    }
    // Converte para inteiro
    const index = list.filter(x => !listExpanded.includes(x))[0];
    
    setListExpanded([ ...list ]);

    if (index === undefined) return;

    const row = tableRef?.getRowModel()?.rows?.find((item) => item.id === index);
    if (row.depth > 0 || dados[index].items) return; // Ja carregado
    const id = dados[index].id;

    loadProductsFromUser(id, index);
  }

  function loadProductsFromUser(id, index) {
    if (!id) return;

    UserService.fetchProductsByUserId(id)
      .then(response => response.json())
      .then((result) => {
        result.map((item) => {
          item.name = item.label;
          if (item.items?.length > 0) {
            item.items.map((item2) => {
              item2.name = item2.label;
              if (item2.items?.length > 0) {
                item2.items.map((item3) => item3.name = item3.label);
              }
            });
          }
        });

        const idx = index === -1 ? dados.findIndex((item) => item.id === id) : index;
        
        dados[idx].items = [ ...result ];
        setDados([ ...dados ]);
        setUser({ ...dados[idx] });
      });
  }

  function loadCustomers() {
    CustomerService.getCustomers()
      .then((response) => {
        if (ResponseStatus.OK === response.status) {
          return response.json();
        }

        return ([]);
      })
      .then((result) => {
        setCustomers(result);
      });
  }
  
  const updatedCustomer = () => {
    setMessage({ hasError: false, text: 'Usuário atualizado com sucesso' });
    setOpenCustomer(false);
  };

  const saveUser = async (user) => {
    try {
      const oper = user.id > 0 ? 'alterar' : 'cadastrar';
        
      UserService.registerUser(user)
        .then(async (response) => {
          const result = await response.json();
          if (response.ok) {
            const idx = dados.findIndex((item => item.id === result.id));
            if (idx === -1) {
              dados[dados.length] = { ...result };
            } else {
              const data = [ ...dados ];
              data[idx] = { ...result };
              setDados([ ...data ]);
            }
            
            const operacao = user.id > 0 ? 'alterado' : 'cadastrado';
            setMessage({ hasError: false, text: `Usuário ${operacao} com sucesso` });
            setCanvasClose(true);

            if (user.id > 0) {
              // sendNotification(user.id, user.products);
            }
          }
          else {
            if (result.details) {
              setMessage({ hasError: true, text: `Usuário "${user.username}": ${result.details[0]}` });
            }
            else {
              setMessage({ hasError: true, text: `Problema ao ${oper} o usuário "${user.username}".` });
            }
          }
        })
        .catch(() => {
          setMessage({ hasError: true, text: `Problema ao ${oper} o usuário "${user.username}".` });
        })
        .finally(() => {
          setSaving(false);
        });
    }
    catch (e) {
      setMessage({ hasError: true, text: "Problema ao salvar usuário." });
    }
    finally {
      setSaving(false);
    }
  }

  function sendNotification(userId, prods) {
    const mapItems = [];
    products.map((level1) => {
      level1.items?.map((level2 => {
        if (level2.items) {
          level2.items?.map((level3) => mapItems.push({ item: `${level1.label}/${level2.label}/${level3.label}`, id: `${level1.id}-${level2.itemId}-${level3.itemId}`}))
        } else {
          mapItems.push({ item: `${level1.label}/${level2.label}`, id: `${level1.id}-${level2.itemId}`})
        }
      }))
    });

    const initIds = [];
    products.map((level1) => {
      initIds.push(`${level1.id}`);
      level1.items?.map((level2 => {
        initIds.push(`${level1.id}-${level2.id}`);
        level2.items?.map((level3) => initIds.push(`${level1.id}-${level2.id}-${level3.id}`))
      }))
    });

    const ids = [];
    prods.map((level1) => {
      ids.push(`${level1.id}`);
      level1.items?.map((level2 => {
        ids.push(`${level1.id}-${level2.id}`);
        level2.items?.map((level3) => ids.push(`${level1.id}-${level2.id}-${level3.id}`))
      }))
    });

    const intersection = ids.filter((item) => !initIds.includes(item));

    const content = intersection.map((item) => {
      return mapItems.find((iten) => item === iten.id).item;
    }).join(",");

    if (content.length > 0) {
      NotificationService.menuNotification({ userId, content });
    }
  }

  const buttons = (
    <Tooltip arrow title="Gráfico acessos">
      <IconButton onClick={(event) => {
        event.stopPropagation();
        setOpenChart(true);
      }}>
        <ChartIcon />
      </IconButton>
    </Tooltip>
  );

  function getButtons(row) {
    return (
      <>
        <TableIconButton tooltip="Seleciona clientes"
          onClick={(event) => {
            event.stopPropagation();
            setUser({ ...row.original });
            setOpenCustomer(true);
          }}
        >
          <ContactsRoundedIcon/>
        </TableIconButton>
        <TableIconButton tooltip="Acessos"
          onClick={(event) => {
            event.stopPropagation();
            setUser({ ...row.original });
            setOpenReport(true);
          }}
        >
          <ReportIcon/>
        </TableIconButton>
      </>
    );
  }
  
  const buildTable = () => {
    const columns = useMemo(
      () => [
        {
          header: "Nome", accessorKey: "name", //minSize: '70', size: '80', maxSize: '100',
          enableHiding: false, grow: true,
        },
        {
          header: "Usuário", accessorKey: "username", //size: 176, grow: false,
          enableHiding: false, grow: true,
        },
        {
          header: "E-mail", accessorKey: "email", //size: 152,  grow: false,
          //enableColumnDragging: false,
          grow: true,
        },
      ],
      []
    );

    return <Table
      title='Usuários'
      columns={columns}
      data={dados}
      setTableRef={setTableRef}
      isLoading={isLoading}
      canvas={{
        title: "Usuário",
        fields: RegisterCanvas({ data: user, menu: products, saveUser, setValidCanvas, isSaving }),
        close: canvasClose,
        isSaving,
        isValidCanvas: isValidCanvas,
        handleOnRegister: () => { setSaving(true) },
        openingCanvas: (values) => {
          if (values.name === '') {
            setUser({ id: 0, name: '', username: '', password: null, email: '', items: [] });
          } else if (values.items) {
            setUser(values);
          } else {
            loadProductsFromUser(values.id, -1);
          }
        },
      }}
      editingConditional={(row) => typeof row.parentId === 'undefined'}
      enableColumnOrdering
      enableColumnResizing
      enableEditing
      enableExpanding
      enablePagination
      enablePinning
      enableRowActions
      pagination
      buttonInsertTitle="Novo usuário" // Exibe botão de inserção
      internalActions={buttons}
      // onDelete={handleDeleteRow} // Exibe botão de editar e associa o evento de callback
      moreButtons={getButtons} // Adiciona mais botões de ação
      widthActionCell={96}
      getSubRows={(originalRow) => originalRow.items}
      manualExpand={{
        getRowCanExpand: (row) => row.depth < 3,
        getRowId: (row) => row.index,
      }}
      onExpandedChange={(expanded) => expandUser(expanded)}
    />;
  };

  return (
    <>
      { props?.breadcrumb ? (props.breadcrumb)
        : <div />
      }
      <div style={{ marginTop: 8 }}>
        {buildTable()}
      </div>

      <AccessChartCanvas
        open={openChart}
        onCanvasClose={(oper) => setOpenChart(oper)}
      />

      {customers?.length > 0 && 
        <CustomerCanvas
          open={openCustomer}
          onCanvasClose={(oper) => setOpenCustomer(oper)}
          dados={customers}
          user={user}
          onChange={updatedCustomer}
        />
      }

      <ReportCanvas
        open={openReport}
        onCanvasClose={(oper) => setOpenReport(oper)}
        data={user}
      />
    </>
  );
};
